<div>{{ 'selectDeselectServiceProvider.description' | translate }}</div>
<form
  [formGroup]="form"
  [ngClass]="{ 'was-validated': submitted }"
>
  <div formArrayName="categories">
    <div
      *ngFor="let category of categoriesFormGroup.controls; let i = index"
      [formGroupName]="i"
      class="row align-items-center pt-3"
    >
      <div class="col-auto">
        <base-checkbox
          formControlName="enabled"
          [isChecked]="true"
          [label]="categoryLabelTemplate"
          [labelTemplateContext]="{ category: category.value.name }"
        ></base-checkbox>
      </div>
      <div class="col">
        <base-service-provider-dropdown
          [initialItems]="getBranches(category.value.name)"
          formControlName="branches"
        ></base-service-provider-dropdown>
      </div>
      <div class="col-auto d-flex align-items-center gap-2">
        <div>
          <base-minute-input formControlName="deliveryTime"></base-minute-input>
        </div>
        <div>
          <base-checkbox
            [isChecked]="true"
            formControlName="immediately"
            label="selectDeselectServiceProvider.immediatelyCheckbox"
          ></base-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-center justify-around pt-4">
    <div class="col">
      <base-checkbox
        formControlName="sendToAllAtOnce"
        label="selectDeselectServiceProvider.sendAllCheckbox"
      ></base-checkbox>
    </div>
    <div class="col-auto">
      <div class="d-flex align-items-center gap-2">
        <div>
          <base-minute-input formControlName="deliveryTimeToAll"></base-minute-input>
        </div>
        <div>
          <base-checkbox
            [isChecked]="true"
            formControlName="deliveryTimeImmediately"
            label="selectDeselectServiceProvider.immediatelyCheckbox"
          ></base-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="pt-4">
    <a
      class=""
      href="#"
      (click)="restoreDefaultSettings($event)"
    >
      {{ 'selectDeselectServiceProvider.restoreDefault' | translate }}
    </a>
  </div>

  <div class="modal-footer mt-4 pb-4 px-0">
    <base-button
      color="secondary"
      [label]="isOpenFromStaffRequestModal ? 'action.closeAndSaveInquiry' : 'action.close'"
      [size]="buttonSize.md"
      (click)="modalRef.dismiss()"
    ></base-button>
    <base-button
      class="btn-confirm me-0"
      color="primary"
      label="action.publishSelected"
      [disabled]="isNoSelectedCategories"
      [size]="buttonSize.md"
      (btnClick)="publish()"
    ></base-button>
  </div>
</form>

<ng-template
  #categoryLabelTemplate
  let-category="category"
>
  <div class="d-flex align-items-center ps-6">
    <div class="d-none d-lg-block">{{ 'category' | translate }}</div>
    <i
      [ngbTooltip]="('administration.timeToWait.timeToWaitCategory' | translate) + ' ' + category.toUpperCase()"
      class="ms-2 fa-solid {{ 'fa-circle-' + category }} {{ category }}"
    ></i>
  </div>
</ng-template>

<ng-template #publishConfirmationModal>
  <base-customer-publish-confirmation-modal
    [formValue]="form.getRawValue()"
    [modalRef]="publishConfirmationModalRef"
  ></base-customer-publish-confirmation-modal>
</ng-template>
